export default __webpack_public_path__ + "static/image-15-9d710a9704c0cbade1e57ca046bb9b42.jpg";